import React, { useState, useEffect } from 'react';
import './Header.css';
import LogoHome from './LogoHome'; // Adjust the path based on your project structure
import { FaEnvelope, FaLock, FaUser, FaEye, FaEyeSlash } from 'react-icons/fa'; // Import FaEye and FaEyeSlash
import { auth } from '../firebase'; // Firebase auth import
import {
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  signInWithPopup,
  GoogleAuthProvider,
  signOut,
  onAuthStateChanged,
} from 'firebase/auth';

// SignInModal Component
export const SignInModal = ({
  closeModal,
  email,
  setEmail,
  password,
  setPassword,
  handleGoogleSignIn,
  handleSignIn,
  error,
  setActiveTab,
}) => {
  const [showPassword, setShowPassword] = useState(false); // State to toggle password visibility

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword); // Toggle the password visibility
  };

  return (
    <div className="modal-content">
      <button className="close-button" onClick={closeModal}>X</button>
      <div className="tabs">
        <div className="tab-active" onClick={() => setActiveTab("signIn")}>Sign In</div>
        <div onClick={() => setActiveTab("signUp")}>Register</div>
      </div>
      {error && <p className="error">{error}</p>}
      <div className="form-group">
        <label>Email:</label>
        <div className="input-icon">
          <FaEnvelope className="icon" />
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Your email address"
          />
        </div>
      </div>
      <div className="form-group">
        <label>Password:</label>
        <div className="input-icon">
          <FaLock className="icon" />
          <input
            type={showPassword ? "text" : "password"} // Toggle input type based on password visibility
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Your password"
          />
          <span className="eye-icon" onClick={togglePasswordVisibility}>
            {showPassword ? <FaEye /> : <FaEyeSlash />} {/* Toggle between eye icons */}
          </span>
        </div>
      </div>
      <button className="submit-button" onClick={handleSignIn}>Sign In</button>
      <div className="or-divider"><span>OR</span></div>
      <div className="social-buttons">
        <button className="social-button google" onClick={handleGoogleSignIn}>Sign in with Google</button>
      </div>
    </div>
  );
};

// SignUpModal Component
export const SignUpModal = ({
  closeModal,
  username,
  setUsername,
  email,
  setEmail,
  password,
  setPassword,
  handleGoogleSignIn,
  handleSignUp,
  error,
  setActiveTab,
}) => {
  const [showPassword, setShowPassword] = useState(false); // State to toggle password visibility

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword); // Toggle the password visibility
  };

  return (
    <div className="modal-content">
      <button className="close-button" onClick={closeModal}>X</button>
      <div className="tabs">
        <div onClick={() => setActiveTab("signIn")}>Sign In</div>
        <div className="tab-active" onClick={() => setActiveTab("signUp")}>Register</div>
      </div>
      {error && <p className="error">{error}</p>}
      <div className="form-group">
        <label>Username:</label>
        <div className="input-icon">
          <FaUser className="icon" />
          <input
            type="text"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            placeholder="Pick a username"
          />
        </div>
      </div>
      <div className="form-group">
        <label>Email:</label>
        <div className="input-icon">
          <FaEnvelope className="icon" />
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Your email address"
          />
        </div>
      </div>
      <div className="form-group">
        <label>Password:</label>
        <div className="input-icon">
          <FaLock className="icon" />
          <input
            type={showPassword ? "text" : "password"} // Toggle input type based on password visibility
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Your password"
          />
          <span className="eye-icon" onClick={togglePasswordVisibility}>
            {showPassword ? <FaEye />: <FaEyeSlash />} {/* Toggle between eye icons */}
          </span>
        </div>
      </div>
      <button className="submit-button" onClick={handleSignUp}>Register</button>
      <div className="or-divider"><span>OR</span></div>
      <div className="social-buttons">
        <button className="social-button google" onClick={handleGoogleSignIn}>Register with Google</button>
      </div>
    </div>
  );
};
// Header Component
const Header = () => { 
  const [isScrolled, setIsScrolled] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [activeTab, setActiveTab] = useState('signIn');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [username, setUsername] = useState('');
  const [error, setError] = useState('');
  const [user, setUser] = useState(null); 
  const [dropdownVisible, setDropdownVisible] = useState(false);
// Store the logged-in user
  const validatePassword = (password) => {
    const passwordRegex = /^(?=.*[A-Z])(?=.*\d)/; // Regex for at least one capital letter and one number
    return passwordRegex.test(password);
  };
  useEffect(() => {
    const handleOutsideClick = (e) => {
      if (!e.target.closest('.user-info')) {
        setDropdownVisible(false);
      }
    };

    document.addEventListener('mousedown', handleOutsideClick);
    return () => document.removeEventListener('mousedown', handleOutsideClick);
  }, []);



  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser); // Set the user if authenticated
    });
    return () => unsubscribe();
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const closeModal = () => {
    setShowModal(false);
    setError('');
  };

  const handleSignUp = async (e) => {
    e.preventDefault();
    if (!validatePassword(password)) {
      setError('Password must contain at least one capital letter and one number.');
      return;
    }
    try {
      await createUserWithEmailAndPassword(auth, email, password);
      closeModal();
    } catch (error) {
      setError(error.message);
    }
  };

  const handleSignIn = async (e) => {
    e.preventDefault();
    if (!validatePassword(password)) {
      setError('Password must contain at least one capital letter and one number.');
      return;
    }
    try {
      await signInWithEmailAndPassword(auth, email, password);
      closeModal();
    } catch (error) {
      setError(error.message);
    }
  };

  const handleGoogleSignIn = async () => {
    const provider = new GoogleAuthProvider();
    try {
      await signInWithPopup(auth, provider);
      closeModal();
    } catch (error) {
      setError(error.message);
    }
  };

  const handleSignOut = async () => {
    try {
      await signOut(auth);
    } catch (error) {
      setError(`Failed to sign out: ${error.message}`);
    }
  };

  return (
    <React.Fragment>
      <header className={`header ${isScrolled ? 'scrolled' : ''}`}>
  <div className="header-content">
    <div className="logo-container">
      <LogoHome />
    </div>
    <div className="actions-container">
      {!user ? (
        <>
          <button
            onClick={() => {
              setShowModal(true);
              setActiveTab('signIn');
            }}
            style={{
              padding: '8px 12px',
              border: '1.5px solid #03EF62',
              borderRadius: '5px',
              background: 'transparent',
              fontSize: '0.9rem',
              cursor: 'pointer',
             fontFamily: "'Arial', sans-serif",
              color: '#ffffff'
            }}
            onMouseEnter={(e) => {
              e.target.style.background = '#03EF62'; // Green background on hover
              e.target.style.color = '#05192D'; // Change text color to black
            }}
            onMouseLeave={(e) => {
              e.target.style.background = 'transparent'; // Revert background
              e.target.style.color = '#ffffff'; // Revert text color
            }}
          >
            Log In
          </button>
          <button
            onClick={() => {
              setShowModal(true);
              setActiveTab('signUp');
            }}
            className="header-button"
          >
            Register
          </button>
        </>
      ) : (
        <div className="user-info">
  <div 
    className="initials-circle" 
    onClick={() => setDropdownVisible((prev) => !prev)} 
    style={{ cursor: 'pointer' }}
  >
    <span className="user-initials">{user?.email?.charAt(0).toUpperCase()}</span>
  </div>
  {dropdownVisible && (
    <div className="dropdown-menu">
      <button className="dropdown-item" onClick={handleSignOut}>
        Sign Out
      </button>
    </div>
  )}
</div>

      )}
    </div>
  </div>
</header>


      {showModal && (
        <div className="modal">
          {activeTab === 'signIn' ? (
            <SignInModal
              closeModal={closeModal}
              email={email}
              setEmail={setEmail}
              password={password}
              setPassword={setPassword}
              handleGoogleSignIn={handleGoogleSignIn}
              handleSignIn={handleSignIn}
              error={error}
              setActiveTab={setActiveTab}
            />
          ) : (
            <SignUpModal
              closeModal={closeModal}
              username={username}
              setUsername={setUsername}
              email={email}
              setEmail={setEmail}
              password={password}
              setPassword={setPassword}
              handleGoogleSignIn={handleGoogleSignIn}
              handleSignUp={handleSignUp}
              error={error}
              setActiveTab={setActiveTab}
            />
          )}
        </div>
      )}
    </React.Fragment>
  );
};

export default Header;
